<template>
  <div class="slide-drawer" v-show="isMobile">
    <!-- 遮罩层 -->
    <transition name="fade">
      <div class="drawer-overlay" v-if="visible" @click="close"></div>
    </transition>

    <!-- 抽屉面板 -->
    <div class="drawer-panel" :class="{ open: visible }"
         @touchstart="onTouchStart"
         @touchend="onTouchEnd">
      <!-- 顶部标题栏：带关闭按钮 -->
      <div class="drawer-header">
        <h3>菜单</h3>
        <span class="close-btn" @click="close" aria-label="关闭">×</span>
      </div>

      <div class="drawer-content">
        <!-- 1️⃣ 快捷功能：4 宫格 -->
        <div class="drawer-quick-actions">
          <div class="action-item" @click="emitAction('queryNpc')">NPC定位</div>
          <div class="action-item" @click="emitAction('queryItem')">货物查询</div>
          <div class="action-item" @click="emitAction('seekRadar')">寻物雷达</div>
          <div class="action-item" @click="emitAction('showProfile')">个人资料</div>
        </div>

        <!-- 🔗 外部链接：电子公告牌、王都地图、聊天动作 -->
        <div class="drawer-ext-links">
          <a class="ext-link" target="_blank" href="https://tieba.baidu.com/f?kw=%E5%B9%BB%E4%B9%8B%E5%A4%A7%E5%9C%B0">电子公告牌</a>
          <a class="ext-link" @click="openMap">王都地图</a>
          <!-- 聊天动作内容未做好，暂隐藏（2026-10-03） -->
          <!-- <a class="ext-link" target="_blank" href="http://blog.huanzhidadi.com/article/chat_movement.html">聊天动作</a> -->
        </div>

        <!-- 2️⃣ 场景区：可滚动，自适应剩余空间 -->
        <div class="drawer-scene">
          <slot></slot>
        </div>

        <!-- 3️⃣ 聊天区：底部 -->
        <div class="drawer-chat">
          <div class="drawer-chat-body">
            <slot name="chat"></slot>
          </div>
        </div>
      </div>

      <!-- 王都动态地图弹窗（不开新页） -->
      <wangdu-dialog ref="wangduDialog"></wangdu-dialog>
    </div>
  </div>
</template>

<script>
import wangduDialog from './maps/wangduDialog.vue';
export default {
  name: 'SlideDrawer',
  components: { wangduDialog },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      visible: false,
      touchStartX: 0,
      touchStartY: 0,
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.$root.eventHub.$on('toggleDrawer', this.toggle);
    this.$root.eventHub.$on('closeDrawer', this.close);
    this.$root.eventHub.$on('openDrawer', this.open);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    this.$root.eventHub.$off('toggleDrawer', this.toggle);
    this.$root.eventHub.$off('closeDrawer', this.close);
    this.$root.eventHub.$off('openDrawer', this.open);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    toggle() {
      this.visible = !this.visible;
      this.toggleBodyScroll();
    },
    open() {
      this.visible = true;
      this.toggleBodyScroll();
    },
    close() {
      this.visible = false;
      this.toggleBodyScroll();
    },
    openMap() {
      // 先收抽屉再呼地图弹窗，避免抽屉压在弹窗下层挡视线
      this.close();
      this.$refs.wangduDialog.open();
    },
    toggleBodyScroll() {
      if (this.visible) {
        document.body.classList.add('drawer-open');
      } else {
        document.body.classList.remove('drawer-open');
      }
    },
    emitAction(action) {
      this.$root.eventHub.$emit('drawerAction', action);
    },
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
    },
    onTouchEnd(e) {
      const deltaX = e.changedTouches[0].clientX - this.touchStartX;
      const deltaY = e.changedTouches[0].clientY - this.touchStartY;

      // 右滑打开抽屉（从屏幕左边缘）
      if (deltaX > 60 && Math.abs(deltaX) > Math.abs(deltaY) && this.touchStartX < 30) {
        this.open();
      }
      // 左滑关闭抽屉
      if (deltaX < -60 && Math.abs(deltaX) > Math.abs(deltaY) && this.visible) {
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.slide-drawer {
  pointer-events: none;
}

.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 400;
  pointer-events: auto;
}

/* ============ 抽屉面板：方案 A 三段式 ============ */
.drawer-panel {
  position: fixed;
  top: 0;
  left: -100%;
  width: 320px;
  max-width: 90vw;
  height: 100vh;
  height: 100dvh;
  background: #1a0a2e;
  z-index: 500;
  transition: left 0.3s ease;
  pointer-events: auto;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
}

.drawer-panel.open {
  left: 0;
}

/* 顶部抽屉标题栏 */
.drawer-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #2a1542;
  border-bottom: 1px solid #4a148c;
}
.drawer-header h3 {
  margin: 0;
  color: #e0a0ff;
  font-size: 14px;
  font-weight: 600;
}
.drawer-header .close-btn {
  color: #ddd;
  font-size: 22px;
  line-height: 1;
  padding: 4px 10px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 4px;
  user-select: none;
}
.drawer-header .close-btn:active {
  background: rgba(123, 31, 162, 0.5);
}

.drawer-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 1️⃣ 快捷功能：4 宫格，固定高度 */
.drawer-quick-actions {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  padding: 10px 12px;
  background: #1a0a2e;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 4px;
  color: #f0e6d2;
  font-size: 12px;
  background: linear-gradient(180deg, #4a3f5c 0%, #3d3250 100%);
  border: 1px solid #5a4f6c;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s;
  text-align: center;
  min-height: 0;
  user-select: none;
  letter-spacing: 0.5px;
}
.action-item:active {
  background: linear-gradient(180deg, #5a4f6c 0%, #4a3f5c 100%);
  border-color: #d4a574;
}

/* 🔗 外部链接行 */
.drawer-ext-links {
  flex: 0 0 auto;
  display: flex;
  gap: 8px;
  padding: 6px 12px 4px;
  background: #1a0a2e;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.ext-link {
  flex: 0 0 auto;
  padding: 6px 10px;
  color: #f0e6d2;
  text-decoration: none;
  font-size: 12px;
  line-height: 1.4;
  background: linear-gradient(180deg, #4a3f5c 0%, #3d3250 100%);
  border: 1px solid #5a4f6c;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
}
.ext-link:active {
  background: linear-gradient(180deg, #5a4f6c 0%, #4a3f5c 100%);
  border-color: #d4a574;
}

/* 2️⃣ 场景区（homeleft / streetleft）：可滚动，自适应内容；多出空间归属聊天 */
.drawer-scene {
  flex: 0 1 auto;
  min-height: 100px;
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 4px 8px 8px 8px;
  background: #1a0a2e;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

/* 抽屉内隐藏头像/罗盘行，把空间留给聊天区 */
.drawer-scene ::v-deep .user-row {
  display: none !important;
}

/* homeleft 在抽屉内的样式重置 - 紧凑模式 */
.drawer-scene ::v-deep .warp {
  display: block !important;
  width: 100% !important;
  padding: 0 !important;
  color: #ddd;
}
.drawer-scene ::v-deep .warp .el-row {
  margin-bottom: 0 !important;
  padding: 0 !important;
  display: block !important;
}
.drawer-scene ::v-deep .warp .el-col {
  padding: 0 !important;
  min-height: 0 !important;
  height: auto !important;
}
.drawer-scene ::v-deep .left {
  display: block !important;
  height: auto !important;
  width: 100% !important;
  padding: 0 !important;
}
.drawer-scene ::v-deep .userface {
  display: none !important;
}
.drawer-scene ::v-deep .userdetails {
  display: block !important;
  width: 100% !important;
  padding: 6px 8px !important;
  color: #e0a0ff !important;
}
.drawer-scene ::v-deep .userdetails .name {
  color: #fff !important;
  font-size: 13px !important;
  margin-bottom: 4px;
}
.drawer-scene ::v-deep .userdetails .labelname {
  color: #b39ddb !important;
  font-size: 11px !important;
  padding: 0 !important;
  display: inline-block;
  width: 38% !important;
  text-align: left;
}
.drawer-scene ::v-deep .userdetails .value {
  color: #fff !important;
  font-size: 11px !important;
  padding: 0 !important;
  display: inline-block;
  width: 60% !important;
  text-align: right;
}
.drawer-scene ::v-deep .userdetails .el-row {
  margin-bottom: 1px !important;
  line-height: 16px;
}
/* homeleft 的 functions 链接列表（详细资料/道具列表 等） */
.drawer-scene ::v-deep #functions {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 5px !important;
  padding: 6px 0 !important;
  width: 100% !important;
  border-top: 1px dashed rgba(255,255,255,0.15);
  margin-top: 6px;
}
.drawer-scene ::v-deep #functions a {
  display: inline-block;
  padding: 5px 8px;
  background: #4a148c;
  color: #fff !important;
  font-size: 11px;
  border-radius: 4px;
  text-decoration: none;
  flex: 0 0 auto;
}
.drawer-scene ::v-deep #functions a:active {
  background: #6a1b9a;
}
.drawer-scene ::v-deep .links,
.drawer-scene ::v-deep a {
  color: #ddd !important;
  text-decoration: none;
}
.drawer-scene ::v-deep hr {
  border: none;
  border-top: 1px dashed rgba(255,255,255,0.15);
  margin: 4px 0;
}

/* 3️⃣ 聊天区：底部；占据主要空间 */
.drawer-chat {
  flex: 1 1 0;
  min-height: 200px;
  max-height: 60vh;
  display: flex;
  flex-direction: column;
  background: #0d1a2e;
  border-top: 1px solid #03a9f4;
  overflow: hidden;
}
.drawer-chat-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.drawer-content ::v-deep #chatWrap {
  flex: 1;
  width: 100% !important;
  height: 100% !important;
  max-height: none !important;
  border: none !important;
  padding: 4px 6px !important;
  margin: 0 !important;
}
.drawer-content ::v-deep #con {
  flex: 1;
  width: 100% !important;
  max-width: none !important;
  max-height: none !important;
  height: auto !important;
  overflow: hidden;
  margin: 0 auto !important;
}
.drawer-content ::v-deep #con li {
  max-width: 100% !important;
  width: 100% !important;
  height: 100% !important;
  max-height: none !important;
  font-size: 11px !important;
  line-height: 1.6;
  margin: 0 !important;
  padding: 4px !important;
  text-align: left;
}
.drawer-content ::v-deep .searchdiv {
  width: 100%;
}
.drawer-content ::v-deep #sangForm,
.drawer-content ::v-deep #tit {
  display: flex;
  justify-content: center;
  width: 100%;
}
.drawer-content ::v-deep #sangForm .button {
  font-weight: bold;
  letter-spacing: 1px;
}

/* 抽屉打开时禁止背景滚动 */
body.drawer-open {
  overflow: hidden !important;
  position: fixed !important;
  width: 100% !important;
}

/* 过渡动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 桌面端隐藏 */
@media (min-width: 769px) {
  .slide-drawer {
    display: none;
  }
}
</style>
